import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const respondingWithEmpathy = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.respondingWithEmpathyArticleBody}
      />
    </ArticleBody>
  </div>
);

respondingWithEmpathy.propTypes = {};

export default respondingWithEmpathy;
